import Chart from 'chart.js/auto';
import { logPageImpression } from '../analytics/analytics'

export default function init() {
    if ($(".js__price-research").length === 0) {
        return;
    }

    init_form_from_url()
    updatePriceHistogram()

    $("input.item-manufacturer-name, .js__item-title", ".js__price-research").on("blur", updatePriceHistogram);
    $("select.item-category-id, select.js__item-condition, input.js__item-condition", ".js__price-research").on("change", updatePriceHistogram);
    $(".js__price-research-trigger", ".js__price-research").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        updatePriceHistogram();
    });
}

let priceHistogramChart = null;

function updatePriceHistogram(event) {
    if (!canUpdate()) {
        return;
    }

    let priceHistogramRequest = {};

    priceHistogramRequest.query = encodeURIComponent(getSearchQuery());
    priceHistogramRequest.category = getCategoryId($(".js__price-research"));
    priceHistogramRequest.condition = encodeURIComponent(getSearchCondition());

    $.getJSON(
        '/api/price/histogram',
        priceHistogramRequest,
        function (data) {
            renderPriceHistogram(data.data);
            logPageImpression()
        }
    );

    update_url(priceHistogramRequest.category, priceHistogramRequest.query)
    create_search_link()
}
function renderPriceHistogram(data) {
    let $chart = $("#js__price-histogram-canvas");

    if ($chart.length === 0) {
        return;
    }

    if (priceHistogramChart !== null) {
        priceHistogramChart.destroy();
    }

    if (data.length === 0) {
        hidePriceHistogram();
        showNoDataAlert();
        return;
    }

    hideNoDataAlert();
    showPriceHistogram();

    priceHistogramChart = new Chart(
        $chart,
        {
            type: 'bar',
            data: transformHistogramData(data),
            options: {
                plugins: {
                    title: {
                        display: true,
                        text: getPriceHistogramTitle(),
                        color: "#ff9900",
                        font: {
                            weight: "bold"
                        }
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            font: {
                                size: 9
                            }
                        },
                        title: {
                            display: true,
                            text: canvasLabelPricerange, // string is defined in php view
                            //text: "Preisbereich (EUR)"
                        }
                    },
                    y: {
                        ticks: {
                            beginAtZero: true,
                            font: {
                                size: 9
                            }
                        },
                        title: {
                            display: true,
                            text: canvasLabelRatio, // string is defined in php view
                            //text: "Anteil (%)"
                        }
                    }
                }
            }
        }
    );
}

function transformHistogramData(data) {
    let transformed = {
        "labels": [],
        "datasets": [
            {
                data: [],
                backgroundColor: "rgba(255, 153, 0, 0.33)",
                borderColor: "rgba(255, 153, 0, 1.0)",
                borderWidth: 1,
                hoverBackgroundColor: "rgba(255, 153, 0, 0.5)",
                hoverBorderColor: "rgba(255, 153, 0, 1.0)"
            }
        ]
    };

    for (let i = 0; i < data.length; i++) {
        transformed.labels.push(data[i].price_formatted);
        transformed.datasets[0].data.push(data[i].count);
    }

    return transformed;
}

function getPriceHistogramTitle() {
    let searchCondition = getSearchCondition();
    let condition;

    if (searchCondition === "") {
        condition = "alle";
    } else {
        condition = searchCondition.split(".").join(", ");
    }

    return "Erzielte Verkaufspreise für \"" + getSearchQuery() +
        "\" (" + condition + ")";
}

function getSearchQuery() {
    let $itemTitleField = $(".js__item-title");
    if ($itemTitleField.length === 0 || $itemTitleField.val() === "") {
        return;
    }

    let itemTitle = $itemTitleField.val();

    let $itemManufacturerField = $("input.item-manufacturer-name");
    if ($itemManufacturerField.length > 0 && $itemManufacturerField.val() !== "") {
        return $itemManufacturerField.val() + " " + itemTitle;
    }

    return itemTitle;
}

function getSearchCondition() {
    let $itemConditionSelect = $("select.js__item-condition");

    if ($itemConditionSelect.length > 0) {
        return $("select.js__item-condition option:selected").text();
    }

    let $itemConditionCheckboxes = $("input.js__item-condition");

    if ($itemConditionCheckboxes.length === 0) {
        return;
    }

    let conditionQuery = [];

    $itemConditionCheckboxes.each(function (index, element) {
        let $element = $(element);
        if ($element.prop("checked") === true) {
            conditionQuery.push($element.val());
        }
    });

    return conditionQuery.join(".");
}

function showPriceHistogram() {
    $(".js__price-histogram-box").show();
    $('.js__price-histogram-heading').show();
}

function hidePriceHistogram() {
    $(".js__price-histogram-box").hide();
    $('.js__price-histogram-heading').hide();
}

function showNoDataAlert() {
    $(".js__price-histogram-nodata").show();
    $('.js__price-histogram-heading').show();
}

function hideNoDataAlert() {
    $(".js__price-histogram-nodata").hide();
    $('.js__price-histogram-heading').hide();
}

function getCategoryId($form) {
    let $input = $("input.item-category-id", $form);

    if ($input.length === 1) {
        return $input.val();
    }

    let $select = $("select.item-category-id", $form);

    if ($select.length === 1) {
        return $select.val();
    }

    return $form.data("category-id");
}

function canUpdate() {
    return $(".js__item-title", ".js__price-research").val() !== "";
}

function init_form_from_url() {
    const query = document.location.search.substring(1).split('&')
    for (let index in query) {
        let parts = query[index].split('=')
        if (parts[0] === 'cat') {
            let $select = $('select.item-category-id')
            $select.val(parts[1])
        }
        if (parts[0] === 'query') {
            $(".js__item-title").val(decodeURIComponent(parts[1].replace('+', ' ')))
        }
    }
}

function update_url(category, query) {
    window.history.pushState(null, null, document.location.href.split('?')[0] + '?cat=' + category + '&query=' + query)
}

function create_search_link() {
    const url = '/search/' + getSearchQuery().replace(' ', '-')
        + '?q_cat=' + getCategoryId($(".js__price-research"))

    $('.js__price-histogram-search-link')
        .attr('href', url)
        .find('.js__price-histogram-search-link-querystring')
        .text(getSearchQuery());
}

